/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var InfoExtractStatusEnum;

(function (InfoExtractStatusEnum) {
  InfoExtractStatusEnum["DONE"] = "DONE";
  InfoExtractStatusEnum["FAILED"] = "FAILED";
  InfoExtractStatusEnum["PENDING"] = "PENDING";
})(InfoExtractStatusEnum || (InfoExtractStatusEnum = {}));